import template from './text-notification.tpl.pug';

export default {
    selector: 'dbATextNotification',
    template: template(),
    bindings: {
        title: '<',
        message: '<',
        imageUrl: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/notifications/component/text-notification/text-notification.cmpt.js